<template>
  <div class="content">
    <!-- <el-card class="left-bar" :style="{ height: contentHeight }"> -->
    <el-card class="left-bar" :style="{ height: '720px' }">
      <!-- <p>List</p> -->
      <div style="display:flex">
        <el-input size="small" class="search-input" v-model="searchValue" suffix-icon="el-icon-search"></el-input>
        <el-button size="small" type="primary" class="search-button" icon="el-icon-circle-plus-outline"
          @click="createNew">
          {{ $t("message.button.add") }}</el-button>
      </div>

      <div class="left-list">
        <li v-for="item in deslist" :key="item.id" class="list" :class="{ active: item.active }">
          <div class="list-title" :title="item.name" @click="getSub(item)">{{ item.name }}</div>
          <span style="cursor: pointer; height: 24px;line-height: 24px;" class="el-icon-delete"
            @click="deleteItem(item)"> </span>
        </li>
      </div>
    </el-card>
    <el-card class="right-content" :class="{ noEdit: !contentItem.show }" :style="{ height: '720px' }"
      v-loading="loading">
      <!-- <p>Content</p> -->
      <div>
        <span>{{ $t('message.table.name') }} : {{ contentItem.name }} </span>
        <span style="margin-left: 25px"> {{ $t('message.table.type') }} : {{ contentItem.type }} </span>
      </div>
      <div class="show">
        <div style="width:80px;padding-top: 8px;"> {{ $t('message.list.showAttribute') }} : </div>
        <br />
        <div class="wrapper" id="items">
          <div class="item" v-for="tag in tags" :key="tag.value">
            <el-tag :type="tag.type" closable @close="handleClose(tag)">{{ tag.label }} </el-tag>
          </div>
        </div>

      </div>
      <el-divider><i class="el-icon-mobile-phone divider"></i></el-divider>
      <div class="buttons">
        <el-button size="small" :disabled="!contentItem.show" type="primary" class="search-button"
          icon="el-icon-circle-check" @click="submit"> {{ $t("message.button.save") }}</el-button>
        <el-button size="small" :disabled="!contentItem.show" type="success" class="search-button"
          icon="el-icon-refresh-left" @click="reset"> {{ $t("message.button.reset") }}</el-button>
      </div>
      <div style="margin-top:45px">
        <el-form>
          <el-form-item :label="$t('message.list.Separator')">
            <!-- <el-select style="width:60%" v-model="contentItem.separatorVar" :options="separatorList"   size="small">
          </el-select> -->
            <div class="selectGroup">
              <div>
                <el-select v-model="contentItem.separatorVar" :options="separatorList">
                  <el-option v-for="i in separatorList" :key="i.value" :label="i.label" :value="i.value">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-left: 25px"> {{ $t('message.table.isEnabled') }} : <el-switch v-model="usedFlag"
                  active-color="#13ce66">
                </el-switch>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-for="(item, index) in tagList" :key="item.label" :label="item.page">
            <div class="selectGroup">
              <div>
                <el-select ref="select" v-model="item.value" multiple :placeholder="$t('message.placeholder.search')"
                  @change="(query) => { remoteMethod(query, item.label, index) }">
                  <el-option v-for="i in item.options" :key="i.value" :label="i.label" :value="i.value">
                  </el-option>
                </el-select>
              </div>
              <div>

                <span style="margin-left: 25px">{{ $t('message.list.showAttributeName') }} : </span>
                <el-select ref="select" v-model="showColumn[index].value" multiple
                  :placeholder="$t('message.placeholder.search')" @change="getShowColumn">
                  <el-option v-for="i in showColumn[index].list" :key="i.value" :label="i.label" :value="i.value">
                  </el-option>
                </el-select>
              </div>

            </div>
          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="selectM.value" @change="selectManu"> {{ selectM.label }} </el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog v-if="addNew" :title="$t('message.title.create')" :visible.sync="addNew" :append-to-body="true">
      <el-form ref="form" :model="form" label-width="80px">

        <el-form-item :label="$t('message.table.type')" required>
          <el-cascader ref="subClass" style="width:80%" v-model="value" :options="options" :props="optionProps"
            size="small" @change="setSubClassName">
          </el-cascader>
          <div class=" warning-title" :style="{ visibility: showWarnning ? 'visible' : 'hidden' }"> <i
              class="el-icon-warning"></i> {{ $t('message.list.duplicateType') }}</div>
        </el-form-item>


        <el-form-item :label="$t('message.table.name')" required>
          <el-input v-model="form.name" size="small" style="width:80%"></el-input>
        </el-form-item>
        <!-- <el-form-item label="分隔符">
          <el-select v-model="contentItem.separatorVar" style="width:80%"  size="small">
            <el-option
              v-for="i in separatorList"
              :key="i.value"
              :label="i.label"
              :value="i.value">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" size="small" @click="onSubmit"> {{ $t("message.button.save") }}</el-button>
          <el-button size="small" @click="addNew = false"> {{ $t("message.button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import axios from "axios";

const USED_TYPE = 3;
export default {
  data() {
    return {
      loading: false,
      list: [],
      addNew: false,
      form: {
        name: "",
        separatorVar: 1
      },
      value: [],
      options: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      separatorList: [
        { label: '|', value: 1 },
        { label: '\\', value: 2 },
        { label: '||', value: 3 },
        { label: ',', value: 4 },
      ],
      tags: [],
      // selectM:'',
      selectM: {
        label: this.$t('message.list.manufacturer'),
        value: false
      },
      usedFlag: false,
      contentItem: {
        name: '--',
        type: '--',
        show: false
      },
      searchValue: '',
      // showWarnning:false,
      showColumn: [
        { value: [], list: [], },
        { value: [], list: [], },
        { value: [], list: [], },
      ],

      tagList: [
        { label: 'P1', value: [], options: [], type: '', page: this.$t('message.list.pageOne') },
        { label: 'P2', value: [], options: [], type: 'success', page: this.$t('message.list.pageTwo') },
        { label: 'P3', value: [], options: [], type: 'info', page: this.$t('message.list.pageThree') },
      ],
    };

  },
  computed: {
    // contentHeight: function () {
    //   return this.$store.state.elementHight-40 + "px"; //自定义高度需求
    // },
    deslist() {
      return this.list.filter(i => i.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) != -1);
    },
    showContent() {
      return this.list.some(i => i.active);
    },
    showWarnning() {

      console.log(this.value);
      return !!this.value.length && this.list.some(i => i.subclassId == this.value[1]);
      // if (!this.value.length) {
      //   return false
      // } else{
      //   return this.list.some(i =>i.subclassId == this.value[1]);
      // }

    },
  },

  methods: {
    createNew() {
      this.addNew = true;
      this.form.name = '';
      this.value = [];
      // !this.options.length && this.getOptions();
    },
    setSubClassName(e) {
      this.form.name = this.$refs.subClass.getCheckedNodes()[0].label
    },
    onSubmit() {
      console.log(this.form);
      if (!this.form.name || !this.value.length) {
        this.$message.error(this.$t('message.warning.required'))
        return;
      }
      const [classId, subClassId] = this.value;
      let obj = {
        name: this.form.name,
        classId,
        subClassId,
        usedFlag: 1,
        usedType: USED_TYPE,
        separatorVar: 1
      }
      axios.post(`/pmdm/importTemplate/save${this.params({ subClassId })}`, obj).then(res => {
        this.$message({
          message: res.data.message,
          type: "success",
        });
        return axios.get('/pmdm/importTemplate/selectByUsedType?usedType=' + USED_TYPE)
      }).then(res => {
        this.addNew = false;
        this.list = res.data.object.map((i, e) => {
          i.index = e;
          i.active = false;
          return i;
        });
        const item = this.list.find(i => i.subclassId == subClassId);
        this.getSub(item);
      })

    },
    selectManu() {
      if (this.selectM.value) {
        this.tags.push({ label: this.selectM.label, type: 'warning' })
      } else {
        const n = this.tags.findIndex(i => !i.value);
        this.tags.splice(n, 1);
      }
    },
    handleClose(tag) {
      // 点击单个tag时触发
      this.tags.splice(this.tags.indexOf(tag), 1);
      if (!tag.value) {
        this.selectM.value = false;
        return
      }
      // 与P1，P2，P3 选择框联动
      const value = this.tagList.find(i => i.label == tag.group).value
      value.splice(value.findIndex(i => i == tag.value), 1);
    },
    remoteMethod(values, label, e) {

      const option = this.tagList[e].options;
      let arr = this.tags.filter(i => i.group == label);


      if (arr.length < values.length) { // 增加
        let item = { ...option.find(j => j.value == values[values.length - 1]) };
        this.tags.push(item);
      } else {  // 减少
        const value = arr.find(i => !values.includes(i.value)).value;
        const n = this.tags.findIndex(i => i.value == value);
        this.tags.splice(n, 1);

        if (this.showColumn[e].value.includes(value)) {
          this.showColumn[e].value.splice(this.showColumn[e].value.indexOf(value), 1)
        }
      }
      this.showColumn[e].list = this.tags.filter(i => i.group == label);

    },
    getShowColumn(e) {
      console.log(e);
    },
    deleteItem(e) {
      this.$confirm(
        this.$t("message.confirm.deleteList"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      ).then(_ => {
        axios.get('/pmdm/importTemplate/delete?id=' + e.id).then(res => {
          this.list.splice(e.index, 1);
          this.$message({
            type: "success",
            message: res.data.message,
          });
          // this.list.splice(e.index,1);
          console.log(this.contentItem, e);
          if (this.contentItem.id == e.id) {
            this.getSub({ name: "--", show: false, type: "--" });
          }
        })
      })

    },
    getOptions() {
      axios
        .get("/pmdm/admin/cls/getClsesWithSubClses?baseClsId=101")
        .then((res) => {
          this.options = res.data.object.clses;
        });
    },
    async getData(e) {
      const { data } = await this.$http.get(
        `pmdm/admin/cls/getSubClassTableColumnInfo${this.params(e)}`);
      return data
    },
    getSub(e) {

      if (e.active) {
        return;
      }
      // console.log(e);
      this.contentItem = { ...e, show: true };


      this.tags = [];
      this.tagList.map((i, e) => {
        i.value = [];
        i.options = [];
        this.$set(this.showColumn, e, { value: [], list: [] })
      })

      this.list.map(i => i.active = false);
      if (!this.contentItem.subclassId) {
        this.contentItem.show = false;
        return
      }
      e.active = true;

      const obj = this.options.find(i => i.id == this.contentItem.classId).children;
      const type = obj.find(j => j.id == this.contentItem.subclassId).name;
      this.$set(this.contentItem, 'type', type)

      this.loading = true;
      const list = new Array(3).fill('_').map((i, index) => {
        return this.getData({ subClsId: e.subclassId, tableId: index + 1 })
      })

      Promise.all(list).then(res => {
        Object.values(res).map((i, index) => {
          // console.log(i.object);
          const colInfo = i.object.colInfo;
          let list = [];
          colInfo.names.map((j, e) => {
            // if (colInfo.visible[e]) {
            //   // list.push({value:colInfo.ids[e],label:j,group:'P' + (index+1),type:this.tagList[index].type})
            // }
            list.push({ value: colInfo.ids[e], label: j, group: 'P' + (index + 1), type: this.tagList[index].type })
          });
          this.tagList[index].options = [...list];
        });
        // console.log(arr);
        return axios.get('/pmdm/importTemplate/selectById?id=' + e.id)
      }).then(res => {
        this.usedFlag = !!res.data.object.usedFlag;
        // console.log(res.data.object.pageOne);
        if (!res.data.object?.pageOne) {
          this.loading = false;
          this.selectM.value = false;
          return;
        }
        let arr = res.data.object?.pageOne.split(';').map(i => {
          const list = i.split('_');
          return { group: list[0], id: +list[1], showColumn: +list[2] }
        })

        arr.map(i => {
          const n = this.tagList.findIndex(j => j.label == i.group);
          if (n == -1) {
            this.selectM.value = true;
            this.tags.push({ label: this.selectM.label, type: 'warning' })
          } else {
            this.tagList[n].value.push(i.id);
            // console.log(this.tagList[n]);
            const item = this.tagList[n].options.find(j => j.value == i.id);
            this.tags.push(item);
            this.showColumn[n].list.push(item);
            i.showColumn && this.showColumn[n].value.push(i.id)
          }
        })
        this.loading = false;
      })
    },
    getList() {
      axios.get('/pmdm/importTemplate/selectByUsedType?usedType=' + USED_TYPE).then(res => {
        console.log(res);
        this.list = res.data.object.map((i, e) => {
          i.index = e;
          i.active = false;
          return i;
        });
      })
    },
    reset() {
      this.getSub(this.contentItem);
    },
    submit() {
      // console.log(this.tags);
      this.loading = true;
      let list = [];
      this.showColumn.map(i => list = [...list, ...i.value])

      const { id, name, classId, separatorVar, subclassId: subClassId } = this.contentItem;

      const obj = {
        id, name, classId, subClassId, separatorVar,
        usedFlag: this.usedFlag ? 1 : 0,
        usedType: USED_TYPE,
        pageOne: '',
      };
      obj.pageOne = this.tags.map(i => {
        if (!i.value) {
          return "M"
        } else {
          const num = list.includes(i.value) ? 1 : 0;
          return i.group + '_' + i.value + '_' + num;
        }
      }).join(';');

      axios.post(`/pmdm/importTemplate/save${this.params({ subClassId, id })}`, obj).then(res => {

        this.loading = false;
        this.$message.success(res.data.message);
      })

    },
    sortEl() {
      var that = this
      var el = document.getElementById('items');

      // 常用
      new Sortable(el, {
        animation: 350,
        onEnd: function (evt) {

          const item = that.tags[evt.oldIndex];

          that.tags.splice(evt.newIndex, 0, that.tags.splice(evt.oldIndex, 1)[0])
          var newArray = that.tags.slice(0)
          that.value = [];

          // 与P1，P2，P3 选择框联动
          if (item?.value) {
            const arr = newArray.filter(i => i.group == item.group);
            that.tagList.find(i => i.label == item.group).value = [...arr.map(i => i.value)];
          }

          that.$nextTick(function () {
            that.tags = newArray
            // console.log(that.tags)
          })
        }
      })

    }
  },
  mounted() {
    console.log(this.$store.state.elementHight);
    this.sortEl();
  },
  created() {
    this.getList();
    this.getOptions();
    console.log(this.contentItem);
    // this.getSub({subclassId:9020161});
  }
};
</script>

<style scoped>
.content {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  background: #fff;
  padding-top: 10px
}

.left-bar {
  min-width: 360px;
  /* width: 340px; */
  /* border: 1px solid salmon; */
  margin-left: 15px;
  padding: 5px 10px;
  margin-bottom: 15px;
}

.active {
  background: #409EFF;
  color: #fff;
  border-radius: 3px;
}

.warning-title {
  margin-top: -10px;
  margin-bottom: -16px;
  color: #e6a23c;
}

.search-input {
  display: inline-block;
  /* width: 72%; */
}

.search-button {
  margin-left: 5px;
}

.left-list {
  /* padding-right: 15px; */
  height: 620px;
  overflow: auto;
  margin-top: 15px;
}

.left-list li {
  line-height: 24px;
  height: 24px;
  padding: 5px 10px;
  font-size: 14px;
  margin: 5px 0;
  transition: 0.4s;
}

.list {
  display: flex;
}

.list-title {
  cursor: pointer;
  width: 265PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-list li:hover {
  /* cursor: pointer; */
  background: #409EFF;
  color: #fff;
  border-radius: 3px;
  transition-delay: 50ms;
}

.right-content {
  flex-grow: 1;
  margin: 0 15px;
  margin-bottom: 15px;
  /* border-left: 1px solid salmon; */
  padding: 5px 15px;
  height: 600px;
  font-size: 14px;
}

.noEdit {

  pointer-events: none;
  /* position: absolute; */
  /* z-index: 2000;
    background-color: rgba(0,0,0,.1);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity .3s;
    transition: opacity .3s; */

  /*兼容IE8及以下版本浏览器*/
}

.divider {
  opacity: 0.6;
}

.buttons {
  float: right;
  margin-right: 60px;
  height: 60px;
  /* width: 100%; */
}

.show {
  display: flex;
  height: 60px;
  margin-top: 15px;
}

.selectGroup {
  display: flex;
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
}

.item {
  font-size: 14px;
  margin: 5px 2px;
}

/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 6px;
  height: 9px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/
::-webkit-scrollbar-track {
  width: 6px;
  background-color: #e9e9eb;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条的设置*/
::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: #aaaaaa;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条移上去的背景*/
::-webkit-scrollbar-thumb:hover {
  background-color: #fff;
}
</style>
